import {DomainQuotaDefaultsQueryResult, useDomainQuotaDefaultsQuery} from "../queries.generated";
import {useCallback} from "react";
import {DomainQuotaDefaultsInfo} from "@/api";
import {useDomainNameQuery} from "@/queries.generated";

export type IdName = {
    id: number;
    name: string;
};

export type DataSource = {
    loading: boolean;
    refetch: () => Promise<DomainQuotaDefaultsInfo>;
    domainName: string;
    data: DomainQuotaDefaultsInfo;
};

const createData = (data?: DomainQuotaDefaultsQueryResult["data"]): DomainQuotaDefaultsInfo => {
    if (!data) {
        return {
            defaultUserPackage: undefined,
            defaultDevices: [],
            defaultCapabilities: [],
            availableUserPackages: [],
            availableCapabilities: [],
        };
    }

    if (!data.domainQuotaDefaults.defaultUserPackage && data.domainQuotaDefaults.availableUserPackages.length > 0)
        data.domainQuotaDefaults.defaultUserPackage = data.domainQuotaDefaults.availableUserPackages[0];

    if (data.domainQuotaDefaults.defaultCapabilities === null) data.domainQuotaDefaults.defaultCapabilities = [];

    return data.domainQuotaDefaults;
};

export function useDataSource(domainId: number): DataSource {
    const domainDefaultsQuery = useDomainQuotaDefaultsQuery({
        variables: {
            domainId,
        },
        fetchPolicy: "no-cache",
    });

    const domainNameQuery = useDomainNameQuery({
        variables: {
            id: domainId,
        },
        fetchPolicy: "no-cache",
    });

    const refetch = useCallback(async () => {
        const newData = await domainDefaultsQuery.refetch();
        return createData(newData.data);
    }, [domainDefaultsQuery]);

    if (domainDefaultsQuery.loading || domainNameQuery.loading)
        return {
            loading: true,
            refetch,
            domainName: "",
            data: createData(),
        };

    return {
        loading: false,
        refetch,
        domainName: domainNameQuery.data.domains.items[0].name,
        data: createData(domainDefaultsQuery.data),
    };
}
